import { autoinject, bindable, bindingMode, transient, customElement } from 'aurelia-framework';
import { DataService, GetPageModeEnum } from 'DataAccessLayer/Services/DataService';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { I18N } from 'aurelia-i18n';
import { Router } from 'aurelia-router';
import { AuthService } from 'DataAccessLayer/Services/AuthService';

@customElement('review-list')
@autoinject
export class ReviewListCustomElement extends BaseCustomElement {
    @bindable({ defaultBindingMode: bindingMode.toView }) aircraftId: number = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) reviewList: Array<any> = [];
    @bindable({ defaultBindingMode: bindingMode.toView }) showLink: boolean = false;
    protected dataService: DataService = null;
    protected authService: AuthService = null;

    protected router: Router = null;
    protected element: any = null;
    protected i18n: I18N = null;
    protected schema: Object = null;
    protected i18nLocale: string = null;
    protected customElement: any = null;

    constructor(dataService: DataService, element: Element, router: Router, i18n: I18N, authService: AuthService,) {
        super();

        this.dataService = dataService;
        this.element = element;
        this.router = router;
        this.i18n = i18n;
        this.authService = authService;
    }
    async bind() {

    }

}
